<template>
  <div class="shopM">
    <div style="display: flex">
      <span style="flex: 1"></span>
      <ul class="shopmTitle">
        <!-- style="flex: 1" -->
        <li style="display: flex; justify-content: center; height: 24px">
          <span class="circle"></span>
          <span class="circle"></span>
        </li>
        <span style="display: flex; justify-content: center; font-size: 13px">{{
          $t('component.ShopM.chooseShop')
        }}</span>
      </ul>
      <!-- style="
          flex: 1;
          font-size: 25px;
          cursor: pointer;
          background: url('/Images/setting.png') no-repeat;
          background-position: right 30px bottom;
          background-size: 25%;
        " -->
      <span class="site-select-span" @click="showModal"> </span>
    </div>

    <ul class="shop-list">
      <li v-for="item in ShopList" :key="item.id" class="sContent sbg">
        {{ item.name }}
      </li>
    </ul>

    <a-modal
      v-model:open="visible"
      :footer="null"
      :closable="false"
      :width="$store.getters.get_notMobileView ? '77%' : '86%'"
    >
      <div>
        <ul
          style="
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
          "
        >
          <li @click="showModal" style="cursor: pointer">
            &lt;&lt; {{ $t('common.back') }}
          </li>
          <li>
            <a-button
              @click="chooseSiteConfirm"
              type="primary"
              style="background: #11254a; border-color: #11254a"
              >{{ $t('common.confirm') }}</a-button
            >
          </li>
        </ul>
        <!-- style="display: flex; justify-content: space-between" -->
        <ul class="shopmSearchBox">
          <li style="flex: 1; background: #dddee2; height: 400px; padding: 8px">
            <!-- style="display: flex" -->
            <div class="searchInutBox">
              <!-- style="border: 0; flex: 0 0 120px; margin-right: 10px" -->
              <a-input
                v-model:value="ShopInput"
                :placeholder="$t('component.ShopM.searchShop')"
              >
              </a-input>
              <!-- style="
                  flex: 0 0 20%;
                  height: 30px;
                  background: #395489;
                  border-color: #395489;
                  margin-right: 10px;
                " -->
              <a-button @click="ShopSearchAndChoose" type="primary">{{
                $t('common.searchAndChoose')
              }}</a-button>
              <!-- style="
                  flex: 0 0 20%;
                  height: 30px;
                  background: #395489;
                  border-color: #395489;
                " -->
              <a-button
                @click="selectedShop('all')"
                type="primary"
                :style="{ display: isSingleChoice == '1' ? 'none' : 'block' }"
                >{{ $t('common.chooseAll') }}</a-button
              >
            </div>
            <!-- style="display: flex; height: 90%; margin-top: 8px" -->
            <div
              :class="[
                isSingleChoice == '1'
                  ? '.selectedShopsSignleBtn'
                  : 'selectedShops'
              ]"
            >
              <div class="stationList">
                <ul
                  style="
                    display: flex;
                    padding: 10px;
                    flex-wrap: wrap;
                    color: #395489;
                  "
                >
                  <li
                    @click="selectedShop(s.id)"
                    :class="s.isActive"
                    v-for="s in Shops"
                    :key="s.id"
                  >
                    {{ s.name }}
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'ShopM',
  props: ['isSingleChoice'],
  data() {
    return {
      ShopList: '',
      visible: false,
      Shops: '',
      ShopInput: ''
    };
  },
  methods: {
    showModal() {
      if (this.visible) {
        this.visible = false;
      } else this.visible = true;
    },
    selectedShop(id) {
      let isActive = this.Shops[0].isActive;
      this.Shops.forEach((m) => {
        if (id == 'all') {
          if (this.isSingleChoice != '1') {
            if (!isActive) m.isActive = 'selectedShop';
            else m.isActive = '';
          }
        } else {
          if (m.id == id) {
            if (m.isActive) m.isActive = '';
            else m.isActive = 'selectedShop';
          } else {
            if (this.isSingleChoice == '1') m.isActive = '';
          }
        }
      });
    },
    ShopSearchAndChoose() {
      this.Shops.forEach((m) => {
        if (
          this.ShopInput &&
          m.name.toLowerCase().indexOf(this.ShopInput.toLowerCase()) > -1
        ) {
          m.isActive = 'selectedShop';
        }
      });
    },
    chooseSiteConfirm() {
      let sites = [];
      this.Shops.forEach((m) => {
        if (m.isActive) {
          sites.push(m);
        }
      });

      this.ShopList = sites;
      this.visible = false;
      // 通知父组件店铺列表已变更,触发二维码展示
      this.$emit('shoplist-changed', this.ShopList);
    },
    resetSites(sites) {
      this.ShopList = [];
      // 通知父组件店铺列表已清空
      this.$emit('shoplist-changed', this.ShopList);
      var shops = [];
      var shopCollection = JSON.parse(
        this.$store.getters.get_shop_collection_cache
      ).shops;
      shopCollection.forEach((shop) => {
        shop.isActive = '';
        if (shop.shopLocation == null) {
          shops.push(shop);
        } else if (
          sites.some(
            (s) =>
              s.id == shop.shopLocation.id && s.type == shop.shopLocation.type
          )
        ) {
          shops.push(shop);
        }
      });
      this.Shops = shops;
    }
  }
};
</script>

<style scoped>
.shopM {
  display: flex;
  flex-flow: column;
  background-color: #c6cbd1;
  /* height: 160px; */
  border-radius: 8px;
  color: #3d4d6b;
}
.shopM .circle {
  /* 设置圆点的宽、高、背景颜色，再设置圆点半径所占百分比 */
  width: 4px;
  height: 4px;
  background-color: #3d4d6b;
  border-radius: 50%;
  display: inline-block;
  margin-top: 8px;
  margin-right: 3px;
  margin-bottom: 8px;
}
.site-select-span {
  flex: 1;
  font-size: 25px;
  cursor: pointer;
  background: url('/Images/setting.png') no-repeat;
  background-position: right 30px bottom;
  background-size: 25%;
}
.shop-list {
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
  align-content: flex-start;
  justify-content: space-between;
  height: 105px;
  margin-top: 5px;
  margin-right: 2px;
}
.shopM .sContent {
  border-radius: 4px;
  height: 40px;
  flex: 0 0 45%;
  margin: 6px;
  display: inline-grid;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 0px 5px;
}
.shopM .sbg {
  background-color: white;
}
.stationList {
  flex: 1;
  background: white;
  border-radius: 0px 4px 4px;
  overflow-y: auto;
}
.stationList li {
  background: #edeef0;
  flex: 0 0 24%;
  height: 35px;
  margin: 5px;
  line-height: 32px;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  padding: 0px 7px;
}
.selectedShop {
  background: #a6bce3 !important;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  background: #edeef0;
}

::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  border-radius: 8px;
  background: #c6cad1;
}

.shopmTitle {
  flex: 1;
}

.shopmSearchBox {
  display: flex;
  justify-content: space-between;
}
.searchInutBox {
  display: flex;
}

.selectedShops,
.selectedShopsSignleBtn {
  display: flex;
  height: 90%;
  margin-top: 8px;
}

.searchInutBox > input[type='text'] {
  border: 0;
  flex: 0 0 120px;
  margin-right: 10px;
}
.searchInutBox > button {
  flex: 0 0 20%;
  height: 30px;
  background: #395489;
  border-color: #395489;
  margin-right: 10px;
}
@media (max-width: 1240px) {
  .shopM {
    display: block;
  }
  .shopmTitle {
    flex: 2;
  }
  .shop-list {
    display: block;
    margin-bottom: 10px;
    margin-top: 8px;
  }
  .shopmSearchBox {
    display: flex;
    justify-content: space-between;
  }
  .shopmSearchBox > li {
    width: 100%;
  }
  .shopM .sContent[data-v-70558c97] {
    display: block;
    line-height: 40px;
    text-align: center;
  }
}

@media (max-width: 812px) {
  .site-select-span {
    flex: 0.7;
  }
}

@media (max-width: 736px) {
  .site-select-span {
    flex: 0.8;
  }
}

@media (max-width: 542px) {
  .site-select-span {
    flex: 1.2;
  }

  .selectedShops {
    height: 74%;
  }
  .selectedShopsSignleBtn {
    height: 80%;
  }
  .searchInutBox {
    display: flex;
    flex-direction: column;
    align-items: inherit;
  }
  .searchInutBox > input[type='text'] {
    flex: none;
    margin-bottom: 10px;
  }
  .searchInutBox > button {
    margin-bottom: 5px;
    margin-right: 0px;
  }
  .stationList li {
    flex: 0 0 100%;
    margin: 5px auto;
  }
}
</style>
